import React from "react";
import Image from "next/legacy/image";
import styled from "@emotion/styled";
import { Link } from "../../Link";
import { Typography } from "../../Typography";

const Card = styled.article`
  border-radius: 2px;
  cursor: pointer;
  height: 300px;
  max-width: 100%;
  width: 100%;
  background-color: ${(props) => props.theme.colors.mist};

  &:hover {
    opacity: 0.9;
  }

  @media ${(props) => props.theme.bp.mobileUp} {
    max-width: 260px;
  }
`;

const CardBody = styled.div`
  height: 150px;
  padding: 16px;
`;

const CardLink = styled(Link)`
  text-decoration: none;
`;

export interface Props {
  navigateTo: string;
  title: string;
  bgImg: string;
}

export const LeaderboardCard: React.FC<Props> = ({
  title,
  navigateTo,
  bgImg,
}) => {
  return (
    <CardLink href={navigateTo}>
      <Card>
        <Image
          src={bgImg}
          layout="responsive"
          width={258}
          height={150}
          loading="lazy"
        />
        <CardBody>
          <Typography use="body2" as="h3">
            {title}
          </Typography>
        </CardBody>
      </Card>
    </CardLink>
  );
};
